import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { AuthService } from './auth.service';
import { DataStoreService } from './dataStore.service';
import { UserProfileService } from '../../auth/user-profile/user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class ThemingService {
  themeList: string[] = ['default', 'light', 'dark', 'custom'];
  previousTheme: string;
  currentTheme: string;
  renderer: Renderer2;
  userId: any;
  colorOpt: any;
  prevCustomThemeOpts: any;

  constructor(rendererFactory: RendererFactory2, private dataStore: DataStoreService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  changeTheme(themeName: string, dontUpdatePrevious?: boolean, customThemeOptions?: any) {
    if (!themeName) {
      return;
    }

    if (
      document.body.classList
        .toString()
        .split(' ')
        .indexOf(this.previousTheme) > -1 &&
      themeName !== this.previousTheme
    ) {
      document.body.classList.remove(this.previousTheme.toLowerCase());
    }

    if (dontUpdatePrevious) {
      this.themeList.forEach(item => {
        document.body.classList.remove(item.toLowerCase());
      });
    }

    this.currentTheme = themeName.toLowerCase();

    if (this.previousTheme !== themeName && !dontUpdatePrevious) {
      this.previousTheme = themeName.toLowerCase();
    }

    this.applyCurrentTheme(customThemeOptions);
  }

  getCurrentTheme() {
    return this.currentTheme || 'default';
  }

  applyCurrentTheme(customThemeOptions?: any) {
    if (this.currentTheme) {
      this.renderer.addClass(document.body, this.currentTheme.toLowerCase());

      if (this.currentTheme.toLowerCase() === 'custom' && (customThemeOptions || this.prevCustomThemeOpts)) {
        if (this.prevCustomThemeOpts) {
          this.prevCustomThemeOpts = JSON.parse(JSON.stringify(customThemeOptions));
        }

        this.applyCustomTheme(customThemeOptions || this.prevCustomThemeOpts);
      }
    }
  }

  resetTheme() {
    if (this.previousTheme !== this.currentTheme) {
      document.body.classList.remove(this.previousTheme);
      document.body.classList.remove(this.currentTheme);
      this.currentTheme = null;
      this.previousTheme = null;
    }
  }

  applyCustomTheme(customThemeOpts: any) {
    document.body.style.setProperty('--bg-headerBG', customThemeOpts.headerBG);
    document.body.style.setProperty('--bg-footerTopBG', customThemeOpts.footerTopBG);
    document.body.style.setProperty('--bg-footerBottomBG', customThemeOpts.footerBottomBG);
    document.body.style.setProperty('--bg-buttonBorder', customThemeOpts.buttonBorder);
    document.body.style.setProperty('--bg-buttonHoverBG', customThemeOpts.buttonHoverBG);
    document.body.style.setProperty('--bg-buttonHoverBorder', customThemeOpts.buttonHoverBorder);
    document.body.style.setProperty('--bg-buttonHoverText', customThemeOpts.buttonHoverText);
    document.body.style.setProperty('--bg-buttonText', customThemeOpts.buttonText);
    document.body.style.setProperty('--bg-buttonBG', customThemeOpts.buttonBG);
    document.body.style.setProperty('--fontColor', customThemeOpts.fontColor);
    document.body.style.setProperty('--tabHeadingColor', customThemeOpts.tabHeadingColor);
    document.body.style.setProperty('--tabActiveHeadingColor', customThemeOpts.tabActiveHeadingColor);
  }
}
